import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { styles } from "./wow-badge.css";

@customElement("wow-badge")
export class WowBadge extends LitElement {
  static override styles = [styles];

  @property({ type: String })
  size: "small" | "medium" = "small";

  @property({ type: String })
  primaryColor?: string;

  @property({ type: String })
  secondaryColor?: string;

  override render() {
    if (this.primaryColor) {
      this.style.setProperty("--badge-bg", this.primaryColor);
    }
    if (this.secondaryColor) {
      this.style.setProperty("--badge-color", this.secondaryColor);
    }

    return html`
      <div class="badge ${this.size}">
        <span class="badge-text"><slot></slot></span>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "wow-badge": WowBadge;
  }
}
